<template>
  <div>
    <Html dir="ltr" :lang="locale">
      <Head>
        <Link
          v-for="link in headLinkItems"
          :id="link.id"
          :key="link.id"
          :href="link.href"
          :rel="link.rel"
        />

        <Meta
          v-for="item in headMetaItems"
          :key="item.property"
          :content="item.content"
          :property="item.property"
        />
      </Head>
      <Body>
        <nuxt-layout>
          <nuxt-page />
        </nuxt-layout>

        <client-only>
          <app-dialog-handler :registry="dialogRegistry" />
          <app-toast-notification-handler />

          <app-feature-flag flag="hr_club_dialog">
            <growth-hr-club-dialog-handler />
          </app-feature-flag>

          <app-feature-flag flag="ai_kit_dialog">
            <growth-ai-kit-dialog-handler />
          </app-feature-flag>
        </client-only>
      </Body>
    </Html>
  </div>
</template>

<script lang="ts" setup>
import { dialogRegistry } from "~/shared/dialog/dialog.registry";

import { useSeoContentRoot } from "./business-areas/seo-content/composables/seo-content.hook";

const { $host } = useNuxtApp();
const { locale, availableLocales } = useI18n();

const route = useRoute();

watch(
  () => route.path,
  () => {
    document.documentElement.classList.remove("overflow-hidden");
  },
);

const headLinkItems = computed<
  {
    id: string;
    rel: string;
    href: string;
  }[]
>(() => {
  return [
    {
      id: "i18n-can",
      rel: "canonical",
      href: `${$host}${route.path}`,
    },
  ];
});

const headMetaItems = computed<
  {
    property: string;
    content: string;
  }[]
>(() => {
  const alternateLocales = availableLocales.filter(
    (item) => item !== locale.value,
  );

  return [
    ...alternateLocales.map((locale) => {
      return {
        property: "og:locale:alternate",
        content: locale,
      };
    }),
    {
      property: "og:locale",
      content: locale.value,
    },
  ];
});

useOnboardingAutonomousStart();
useSeoContentRoot();
</script>
